(function () {
  var header = document.getElementById('siteHeader');
  var hero = document.querySelector('.hero');

  function updateHeader() {
    if (!header) return;
    if (!hero) {
      header.classList.add('no-hero');
      return;
    }
    var heroBottom = hero.getBoundingClientRect().bottom;
    header.classList.toggle('is-scrolled', heroBottom <= header.offsetHeight);
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });
  window.addEventListener('resize', updateHeader);

  var menuOpenBtn = document.getElementById('menuOpenBtn');
  var menuCloseBtn = document.getElementById('menuCloseBtn');
  var mobileMenu = document.getElementById('mobileMenu');

  function openMenu() {
    mobileMenu.classList.add('is-open');
    menuOpenBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu.classList.remove('is-open');
    menuOpenBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (menuOpenBtn) menuOpenBtn.addEventListener('click', openMenu);
  if (menuCloseBtn) menuCloseBtn.addEventListener('click', closeMenu);
  if (mobileMenu) {
    mobileMenu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeMenu);
    });
  }

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.reveal');

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  } else {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // Note: email-signup forms are real Shopify customer forms (see
  // sections/email-signup.liquid) and submit normally — no JS interception
  // here. Shopify redirects back with form.posted_successfully? on success.

  // ---------------------------------------------------------------------
  // Product variant selection (sections/main-product.liquid)
  // ---------------------------------------------------------------------
  document.querySelectorAll('.product-info[data-product-id]').forEach(function (info) {
    var productId = info.getAttribute('data-product-id');
    var dataScript = document.querySelector('script[data-product-variants="' + productId + '"]');
    var form = info.querySelector('.product-form');
    if (!dataScript || !form) return;

    var variants;
    try {
      variants = JSON.parse(dataScript.textContent);
    } catch (err) {
      return;
    }

    var variantIdInput = form.querySelector('#ProductFormVariantId');
    var priceEl = info.querySelector('#ProductPrice');
    var submitBtn = form.querySelector('#AddToBagButton');

    function findMatchingVariant() {
      var groups = {};
      form.querySelectorAll('input[type="radio"][name^="option-"]:checked').forEach(function (input) {
        groups[input.getAttribute('data-option-position')] = input.value;
      });
      var positions = Object.keys(groups).sort(function (a, b) { return a - b; });
      if (!positions.length) return null;
      var selected = positions.map(function (p) { return groups[p]; });

      return variants.filter(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      })[0] || null;
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
      }
    }

    form.querySelectorAll('input[type="radio"][name^="option-"]').forEach(function (input) {
      input.addEventListener('change', function () {
        applyVariant(findMatchingVariant());
      });
    });
  });

  // ---------------------------------------------------------------------
  // Product gallery thumbnails (sections/main-product.liquid)
  // ---------------------------------------------------------------------
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.product-gallery-main img');
    var thumbs = gallery.querySelectorAll('.product-gallery-thumbs button');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var thumbImg = thumb.querySelector('img');
        if (!thumbImg) return;
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = thumb.dataset.fullSrc || thumbImg.currentSrc || thumbImg.src;
        mainImg.alt = thumbImg.alt;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  });
})();
